import { createGlobalStyle } from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const CSSReset = createGlobalStyle`

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600&display=swap'); 

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    text-decoration: none;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    font-family: Inter, sans-serif;
    font-size: 1rem;
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  button {
    &[color='primary'] {
      background-color: ${ThemePrisma.colors.pink[4]};
      border-color: ${ThemePrisma.colors.pink[4]};

      &:hover {
        background-color: ${ThemePrisma.colors.pink[5]};
        border-color: ${ThemePrisma.colors.pink[5]};
      }
    }

    &:disabled {
        cursor: not-allowed !important;

        &:hover {
            background: rgb(228, 231, 235);
            border: 1.5px solid rgb(228, 231, 235);
            color: rgb(82, 96, 109);
        }
    }

    &.list-button {
      background: ${ThemePrisma.colors.gray[5]};

      &:hover {
        background: ${ThemePrisma.colors.gray[6]};
        color: rgb(255, 255, 255) !important;
        
        .icon-styles {
          color: rgb(255, 255, 255) !important;
        }
      }
    }
  } 
  .pt-32 {
    padding-top: 32px !important;
  }
  #root {
    position: relative;
  }
` as any;
